/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_History_DescInputs */

const en_settings_history_desc = /** @type {(inputs: Settings_History_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every subscription — active, expired and scheduled.`)
};

const id_settings_history_desc = /** @type {(inputs: Settings_History_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua langganan kamu — aktif, berakhir, dan terjadwal.`)
};

/**
* | output |
* | --- |
* | "Every subscription — active, expired and scheduled." |
*
* @param {Settings_History_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_history_desc = /** @type {((inputs?: Settings_History_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_History_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_history_desc(inputs)
	return en_settings_history_desc(inputs)
});